import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.2 12.9H7.8C8.38348 12.9 8.94306 12.6682 9.35564 12.2556C9.76822 11.8431 10 11.2835 10 10.7V9.35923L13.088 11.212C13.1826 11.268 13.2901 11.2983 13.4 11.3C13.5034 11.3034 13.6057 11.2785 13.696 11.228C13.788 11.1758 13.8646 11.1003 13.918 11.0089C13.9714 10.9176 13.9997 10.8138 14 10.708V4.30803C13.9997 4.20225 13.9714 4.09843 13.918 4.00711C13.8646 3.91579 13.788 3.84021 13.696 3.78803C13.6041 3.73305 13.4991 3.70401 13.392 3.70401C13.2849 3.70401 13.1799 3.73305 13.088 3.78803L10 5.64082V4.30001C10 3.71653 9.76822 3.15695 9.35564 2.74437C8.94306 2.33179 8.38348 2.10001 7.8 2.10001H2.2C1.61652 2.10001 1.05694 2.33179 0.644365 2.74437C0.231785 3.15695 0 3.71653 0 4.30001V10.7C0 11.2835 0.231785 11.8431 0.644365 12.2556C1.05694 12.6682 1.61652 12.9 2.2 12.9ZM10 7.96403V7.03602L12.8 5.35603V9.64403L10 7.96403ZM8.8 6.69664V4.30001C8.8 4.03479 8.69464 3.78044 8.50711 3.5929C8.31957 3.40536 8.06522 3.30001 7.8 3.30001H2.2C1.93478 3.30001 1.68043 3.40536 1.49289 3.5929C1.30536 3.78044 1.2 4.03479 1.2 4.30001V10.7C1.2 10.9652 1.30536 11.2196 1.49289 11.4071C1.68043 11.5947 1.93478 11.7 2.2 11.7H7.8C8.06522 11.7 8.31957 11.5947 8.50711 11.4071C8.69464 11.2196 8.8 10.9652 8.8 10.7V8.30342C8.79999 8.30229 8.79999 8.30116 8.79999 8.30003V6.70003C8.79999 6.6989 8.79999 6.69777 8.8 6.69664Z"
	})]
});
const ForwardRef = forwardRef(SvgVideo);
export { ForwardRef as ReactComponent };
